import React from 'react'
import ControlBoardSwimlanesComponent from './ControlBoardSwimlanes'
import { createSwimlane } from '../../flux/swimlanes/SwimlaneActions'
import { IBoardBase } from '../../flux/boards/BoardStore'
import Dropdown from 'react-bootstrap/Dropdown'
import VerticalDotDropdownToggle from '../bootstrap-extensions/VerticalDotDropdownToggle'
import styles from './Board.module.scss'

/**
 * Data required to represent a board
 */
export interface IBoardView extends IBoardBase {
    swimlaneIds: number[]
}

/**
 * Props passed to the BoardComponent.
 */
export interface IBoardProps {
    board: IBoardView
    canMove: boolean
    canFocus: boolean
    isFocused: boolean
    isHidden: boolean
    onMove: () => void
    onEdit: () => void
    onDelete: () => void
    onFocus: () => void
}

function BoardComponent(props: IBoardProps) {
    return (
        <div
            className={`card border-0 ${styles.card} ${
                props.isHidden ? 'd-none' : ''
            }`}
            aria-label="Board Container">
            <div className={`card-header d-flex rounded-0`}>
                <div className="flex-grow-1 align-self-center">
                    <h6 className="mb-0">{props.board.name}</h6>
                </div>
                {props.canFocus && (
                    <div className="btn-group-toggle">
                        <label
                            className={`btn btn-outline-secondary ${
                                props.isFocused ? 'active' : ''
                            }`}>
                            <input
                                type="checkbox"
                                onChange={props.onFocus}
                                checked={props.isFocused}
                            />
                            Focus
                        </label>
                    </div>
                )}
                <div className="text-secondary">
                    <Dropdown drop="left">
                        <Dropdown.Toggle
                            as={VerticalDotDropdownToggle}
                            className="text-secondary"
                        />
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={props.onDelete}>
                                Delete
                            </Dropdown.Item>
                            <Dropdown.Item onClick={props.onEdit}>
                                Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={props.onMove}
                                disabled={!props.canMove}>
                                Move
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => createSwimlane(props.board.id)}>
                                Add Swimlane
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className="card-body container-fluid">
                <div className="row">
                    <ControlBoardSwimlanesComponent
                        boardId={props.board.id}
                        swimlaneIds={props.board.swimlaneIds}
                    />
                </div>
            </div>
        </div>
    )
}

export default BoardComponent
